import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
const reads = new Map();
async function request(route, data) {
    const token = JwtService.getToken();
    if(!token) throw new Error('Sessão expirada.');
    ApiService.setHeader();
    const result = await ApiService.postOnce(route, data, { timeout: 55000 });
    if(JwtService.getToken() !== token) throw new Error('Sessão alterada.');
    if(result.data?.error) throw new Error(result.data.error.error_user_msg || result.data.error.message || 'Não foi possível concluir a operação.');
    return result.data;
}
const actions = {
    listarTemplatesMensagens(context, dados) {
        const key = JSON.stringify([JwtService.getToken(), dados]);
        if(reads.has(key)) return reads.get(key);
        const promise = request('metaOficial/access/listarTemplatesMensagens', dados).finally(() => reads.delete(key));
        reads.set(key, promise); return promise;
    },
    obterTemplateMensagem(context, dados) { return request('metaOficial/access/obterTemplateMensagem', dados); },
    excluirTemplateMensagem(context, dados) { return request('metaOficial/access/excluirTemplateMensagem', dados); },
    salvarTemplateMensagem(context, dados) { return request('metaOficial/access/salvarTemplateMensagem', dados); },
    obterTemplateMacros(context, dados) { return request('whatsAppTemplateMacros/access/obter', dados); },
    salvarTemplateMacros(context, dados) { return request('whatsAppTemplateMacros/access/salvar', dados); },
    obterCatalogoMacros() { return request('whatsAppTemplateMacros/access/catalogo', {}); }
};
export default { state: {}, actions, mutations: {}, getters: {} };
